(function () {
    'use strict';

    angular
        .module(app.modules.common.name)
        .factory('fileReader', fileReaderFactory);

    var methodMap = { arraybuffer: 'readAsArrayBuffer', binarystring: 'readAsBinaryString', dataurl: 'readAsDataURL', text: 'readAsText' };

    fileReaderFactory.$inject = ['$q'];
    function fileReaderFactory($q) {
        return fileReader;

        // Note: method = 'ArrayBuffer', 'BinaryString', 'DataURL' or 'Text'
        function fileReader(file, method, cancellationToken) {
            var deferred = $q.defer(),
                reader = new FileReader();

            method = methodMap[angular.lowercase(method || 'ArrayBuffer')];
            if (method == null) 
                throw new Error('Invalid method.')

            reader.onloadstart = onloadstart;
            reader.onload = onload;
            reader.onerror = onerror;
            reader.onprogress = onprogress;
            reader.abort = abort;
            reader[method](file);

            if (angular.isObject(cancellationToken)) 
                cancellationToken.cancel = reader.abort.bind(reader);

            return deferred.promise;

            function onloadstart(e){ 
                deferred.notify({ file: file, loaded: 0, total: e.total, lengthComputable: e.lengthComputable, event: e, reader: e.target });
            }

            function onload(e) {
                var result = e.target.result;
                result = result && angular.extend(result, { type: file.type, name: file.name });
                deferred.resolve({ file: file, result: result, event: e, reader: e.target });
            };

            function onerror(e) {
                deferred.reject({ file: file, error: e.target.error, event: e, reader: e.target });
            };

            function onprogress(e) {
                deferred.notify({ file: file, loaded: e.loaded, total: e.total, lengthComputable: e.lengthComputable, event: e, reader: e.target });
            }

            function abort() {
                if (this.readyState === 1) {
                    FileReader.prototype.abort.call(this);
                    deferred.reject({ file: file, error: new CustomDOMError("AbortError"), event: null, reader: reader });
                }
            }
        }
    }


    function CustomDOMError(name) {
        Object.defineProperty(CustomDOMError.prototype, "name", { get: function () { return name; }, enumerable: true, configurable: true });
    }
    // Apple sucks! - CustomDOMError.prototype = Object.create(DOMError.prototype);
    CustomDOMError.prototype.toString = function () { return this.name; }
})();